/**
 * Deep links into the Foundry 2.0 (Vue 3) UI.
 *
 * Route paths are identical between the two apps — only the host differs — so a
 * legacy path can be handed to betaUrlFor() verbatim.
 */

/** Exported for tests: webpack inlines process.env, so the base can't be stubbed. */
export function joinBetaUrl(base: string, path: string): string {
  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

export function betaUiUrl(): string {
  return process.env.VUE_APP_BETA_UI_URL || 'https://beta.thefoundry.tech'
}

export function betaUrlFor(path: string): string {
  return joinBetaUrl(betaUiUrl(), path)
}

export function betaMediaPackageUrl(id: string): string {
  return betaUrlFor(`app/sales/media_package/${id}`)
}

export function betaLineItemUrl(id: string): string {
  return betaUrlFor(`app/line-item/${id}`)
}

export function betaMediaPlanUrl(id: string): string {
  return betaUrlFor(`app/sales/media_plan/${id}`)
}
